<template>
  <Header/>
    <div class="main-error">
       <div>
         <h1>Oupsi, la page demandée n'existe pas !</h1>
       <div class="wrapper">
        <NuxtLink to="/" class="btn">Revenir à l'accueil</NuxtLink>
       <NuxtLink to="/projets" class="btn">Voir mes projets</NuxtLink>
       </div>
       </div>
    </div>
  <Footer/>
</template>

<style lang="scss">
    .main-error{
         padding-top: 150px;
        height: calc(100vh - 210px);
        display: flex;
        align-items: center;
        justify-content: center;
       h1{
         font-family: 'Open Sans',sans-serif ;
         font-weight: 500;
         font-size: 30px;
         color: #9152f7;
         text-align: center;
       }
       .wrapper{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        margin: 50px auto;
       }
        .btn{
        font-size: 16px;
        font-family: 'Open Sans',sans-serif;
        padding: 10px 20px;
        color: $white;
        background-color: $violet;
        border-radius: 50px;
        border:2px solid $violet;
        cursor: pointer;
        width: fit-content;
        text-decoration: none;
        transition: all .2s;
        @media screen and (max-width:1035px) {
            font-size: 16px;
        }
        &:hover{
            background-color: #fff;
            color: #9152F7;
        }
        &-center{
            display: block;
            margin: auto;
        }
        &.space-block{
            margin-block: 20px;
        }
    }
    }
</style>